import { FC, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useLanguagePairContext } from 'src/context/languagePair';
import { FAQItem } from '../FAQItem';
import {
  extraTravelTopicQuestions,
  extraWorkTopicQuestions,
  topicQuestions,
} from './questions.const';

type FAQTopicListComponent = FC<{ topicIconUrl: string }>;

const TOPIC_REGEXP = /\/scenario-icons\/([^-]+)/;

export const FAQTopicList: FAQTopicListComponent = ({ topicIconUrl }) => {
  const intl = useIntl();

  const { targetLanguageLocale } = useLanguagePairContext();

  const questions = useMemo(() => {
    const topic = topicIconUrl.match(TOPIC_REGEXP)?.[1];

    switch (topic) {
      case 'Travel': {
        return [...(extraTravelTopicQuestions[targetLanguageLocale] ?? []), ...topicQuestions];
      }

      case 'Work': {
        return [...(extraWorkTopicQuestions[targetLanguageLocale] ?? []), ...topicQuestions];
      }

      default: {
        return topicQuestions;
      }
    }
  }, [targetLanguageLocale, topicIconUrl]);

  return (
    <>
      {questions.map(question => {
        return (
          <FAQItem
            answer={intl.formatMessage(question.answer)}
            key={question.question.id}
            question={intl.formatMessage(question.question)}
          />
        );
      })}
    </>
  );
};
